import { render, staticRenderFns } from "./ClaimCloseDialog.vue?vue&type=template&id=f30065a6&"
import script from "./ClaimCloseDialog.vue?vue&type=script&lang=js&"
export * from "./ClaimCloseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports